import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'as0072',
    ecrans: ['00-2']
});
